import { render } from "./Decks.vue?vue&type=template&id=0db8183c"
import script from "./Decks.vue?vue&type=script&lang=js"
export * from "./Decks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__